import { ChevronDoubleLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleRightIcon } from '@heroicons/react/24/outline';
import { arrayHasItems } from '../helpers/common';

export const Pagination = ({
    currentItemsPerPage,
    currentPage,
    rangeRows,
    isTheLastPage,
    additionalRanges,
    totalPages,
    setCurrentPage,
    setCurrentItemsPerPage,
    testId
}) => {
    return (
        <section className="flex flex-wrap justify-center gap-4 py-4 md:gap-6 md:py-6">
            <div className="flex gap-4 items-center">
                <span className="whitespace-nowrap">Rows per page:</span>
                <select 
                    data-testid={testId ? `${testId}_select_pagination` : undefined}
                    value={currentItemsPerPage}
                    className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    onChange={(event) => {
                        setCurrentPage(1);
                        setCurrentItemsPerPage(event.target.value);
                    }}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    {arrayHasItems(additionalRanges) && (
                        additionalRanges.map((range, index) => {
                            return <option key={`${range.value}_${index}`} value={range.value}>{range.label}</option>
                        })
                    )}
                </select>
                {rangeRows && (<span className="whitespace-nowrap">{rangeRows}</span>)}
            </div>
            <div className="flex gap-2 items-center">
                <button 
                    className="text-gray-900 disabled:bg-gray-200 bg-white border border-gray-300 p-2 rounded-full cursor-pointer"
                    disabled={currentPage === 1}
                    onClick={() => {
                        setCurrentPage(1)
                    }}
                    type="button"
                >
                    <ChevronDoubleLeftIcon className="w-5 h-5" />
                </button>
                <button 
                    className="text-gray-900 disabled:bg-gray-200 bg-white border border-gray-300 p-2 rounded-full cursor-pointer"
                    disabled={currentPage === 1}
                    type="button"
                    data-testid={testId ? `${testId}_previous_button`: undefined}
                    onClick={() => {
                        if (currentPage > 1) {
                            setCurrentPage(currentPage - 1);
                        }
                    }}
                >
                    <ChevronLeftIcon className="w-5 h-5" />
                </button>
                <button 
                    className="text-gray-900 disabled:bg-gray-200 bg-white border border-gray-300 p-2 rounded-full cursor-pointer"
                    type="button"
                    data-testid={testId ? `${testId}_next_button`: undefined}
                    disabled={isTheLastPage}
                    onClick={() => {
                        setCurrentPage(currentPage + 1);
                    }}
                >
                    <ChevronRightIcon className="w-5 h-5" />
                </button>
                <button 
                    className="text-gray-900 disabled:bg-gray-200 bg-white border border-gray-300 p-2 rounded-full cursor-pointer"
                    type="button"
                    disabled={isTheLastPage}
                    onClick={() => {
                        setCurrentPage(totalPages);
                    }}
                >
                    <ChevronDoubleRightIcon className="w-5 h-5" />
                </button>
            </div>
        </section>
    )
}